import React, { useState } from "react";
import { Grid, Typography, Modal, Box } from "@mui/material";
import Image from "next/image";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CloseIcon from "@mui/icons-material/Close";

import ApostropheImg from "../../../public/assets/images/home/ApostropheImg.webp";
import ApostropheImgInverted from "../../../public/assets/images/home/ApostropheImgInverted.webp";
import youtubeIcon from "../../../public/assets/images/home/youtubeIcon_1.webp";

import Testimonial1 from "../../../public/assets/images/home/Ash-Mohammad_600X300.webp";
import Testimonial2 from "../../../public/assets/images/home/Testimonial2.webp";
import Testimonial3 from "../../../public/assets/images/home/image (3).png";
import Testimonial4 from "../../../public/assets/images/home/Pawan-Sharma_600X300.webp";
import Testimonial5 from "../../../public/assets/images/home/image (2).png";
import Testimonial6 from "../../../public/assets/images/home/image (9).png";
import Testimonial7 from "../../../public/assets/images/home/image (11).png";
import Testimonial9 from "../../../public/assets/images/home/image (4).png";
import Testimonial10 from "../../../public/assets/images/home/image (12).png";
import Testimonial11 from "../../../public/assets/images/home/image (10).png";

const testimonials = [
  Testimonial1,
  Testimonial2,
  Testimonial3,
  Testimonial4,
  Testimonial5,
  Testimonial6,
  Testimonial7,
  Testimonial9,
  Testimonial10,
  Testimonial11,
];

const videoTestimonial = [
  "https://www.youtube.com/embed/D52nUn_m2SI?autoplay=1",
  "https://www.youtube.com/embed/c5xWuPTsRho?autoplay=1",
  "https://www.youtube.com/embed/2DtQPzOacQ4?autoplay=1",
  "https://www.youtube.com/embed/0Vn4xmTze7k?autoplay=1",
  "https://www.youtube.com/embed/E9XHIEHKDhQ?autoplay=1",
  "https://www.youtube.com/embed/Xz9FHEjsIQU?autoplay=1",
  "https://www.youtube.com/embed/cwbmdlRjhCI",
  "https://www.youtube.com/embed/YVJJUwFIBoc",
  "https://www.youtube.com/embed/8xIscsgWN0c?autoplay=1",
  "https://www.youtube.com/embed/AEycpf3OBqU?autoplay=1",
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

function Testimonials() {
  const [showVideo, setShowVideo] = useState(false);
  const [videoId, setVideoId] = useState(0);

  const playFunction = (videoId: any) => {
    setShowVideo(true);
    setVideoId(videoId);
  };

  const pauseFunction = () => {
    setShowVideo(false);
  };

  return (
    <Grid
      container
      sx={{
        minHeight: { xs: "40vh", md: "70vh" },
        padding: { xs: "40px 0 20px 0", md: "80px 0" },
        width: "100%",
        backgroundColor: "#F4F7FF",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <Typography
   
        sx={{
          fontSize: { xs: "24px", md: "40px" },
          textAlign: "left",
          width: "80%",
          color: "#0A0C0F",
          position: "relative",
          zIndex: 2,
          fontWeight: "700",
        }}
      >
        Reviews from our Partners
        <Image
          src={ApostropheImgInverted}
          alt=""
          style={{
            position: "absolute",
            left: "-8px",
            zIndex: -1,
            bottom: "25px",
            width: "auto",
          }}
          id="ApostropheImgInverted"
          loading="lazy"
        />
      </Typography>

      <Grid
        sx={{
          margin: { xs: "20px 0", md: "50px 0" },
          width: "80%",
          maxWidth: "1440px",
        }}
      >
        <Carousel
          autoPlay={!showVideo}
          responsive={responsive}
          // showDots={true}
          containerClass="react-multi-carousel-list"
          itemClass="react-multi-carousel-item"
          infinite={false}
          swipeable={true}
        >
          {testimonials.map((testimonial, index) => (
            <div key={index} style={{ position: "relative" }}>
              <Image
                src={testimonial}
                alt={`GroMo partner video testimonial thumbnail ${index + 1}`}
                style={{
                  width: "545px",
                  objectFit: "contain",
                  height: "360px",
                }}
                onClick={() => playFunction(index)}
                loading="lazy"
              />
              <div
                style={{
                  width: "100%",
                  position: "absolute",
                  top: "32%",
                  right: "0",
                  left: "0",
                }}
              >
                <div style={{ width: "12%", margin: "0 auto" }}>
                  <Image
                    src={youtubeIcon}
                    alt="Play video"
                    style={{
                      width: "120px",
                      objectFit: "contain",
                      height: "120px",
                    }}
                    onClick={() => playFunction(index)}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </Grid>
      <Modal open={showVideo} onClose={pauseFunction}>
        <Box
          sx={{
            position: "absolute",
            top: "10%",
            left: { xs: "2%", md: "10%" },
            width: { xs: "96%", md: "80%" },
            boxShadow: 24,
          }}
        >
          <Grid
            sx={{
              display: "grid",
              placeContent: "center",
              position: "relative",
            }}
          >
            <Box
              component="iframe"
              src={videoTestimonial[videoId]}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sx={{
                width: "100%",
                height: { xs: 200, md: 500 },
                border: 0,
              }}
            />
            <CloseIcon
              onClick={pauseFunction}
              sx={{
                position: "absolute",
                right: "0",
                top: "0",
                fontSize: "30px",
                color: "#FFF",
                cursor: "pointer",
              }}
            />
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
}

export default Testimonials;
